/**
 * Wave 26 — Country SEO i18n
 * New: Cameroon 🇨🇲, Senegal 🇸🇳, Slovakia 🇸🇰
 * Gap-fill: Togo 🇹🇬 (missing EN), Lithuania 🇱🇹 (missing ZH/JA/KO/SV/DA)
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE26: CountrySEOMap = {

  cameroon: {
    fr: {
      title: 'Centre d\'appel Cameroun | Service Client Bilingue FR/EN | Call IT Dev',
      description: 'Externalisez votre centre d\'appel au Cameroun : agents bilingues français/anglais, fuseau WAT, CSAT 95%, dès 3 $/h. 80% d\'économies.',
      heroTitle: 'Centre d\'appel pour le Cameroun — Support bilingue depuis Casablanca',
      heroSubtitle: 'Service client premium bilingue FR/EN pour le marché camerounais. Fuseau WAT, 80% moins cher.',
    },
    es: {
      title: 'Call Center Camerún | Atención Bilingüe FR/EN | Call IT Dev',
      description: 'Call center para Camerún: agentes bilingües francés/inglés, zona WAT, CSAT 95%, desde 3 $/h. 80% ahorro.',
      heroTitle: 'Call Center para Camerún — Soporte Bilingüe desde Casablanca',
      heroSubtitle: 'Atención al cliente bilingüe FR/EN para el mercado camerunés. 80% más barato.',
    },
    de: {
      title: 'Call Center Kamerun | Zweisprachiger Kundenservice FR/EN | Call IT Dev',
      description: 'Call Center für Kamerun: zweisprachige FR/EN-Agenten, WAT-Zeitzone, CSAT 95%, ab 3 $/h. 80% Ersparnis.',
      heroTitle: 'Call Center für Kamerun — Zweisprachiger Support',
      heroSubtitle: 'Premium-Kundenservice FR/EN für den kamerunischen Markt. 80% günstiger.',
    },
    ar: {
      title: 'مركز اتصال الكاميرون | خدمة عملاء ثنائية اللغة FR/EN | Call IT Dev',
      description: 'مركز اتصال للكاميرون: وكلاء ثنائيو اللغة فرنسية/إنجليزية، منطقة WAT، CSAT 95%، من 3 $/ساعة. توفير 80%.',
      heroTitle: 'مركز اتصال للكاميرون — دعم ثنائي اللغة من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة ثنائية اللغة للسوق الكاميروني. توفير 80%.',
    },
    it: {
      title: 'Call Center Camerun | Assistenza Bilingue FR/EN | Call IT Dev',
      description: 'Call center per il Camerun: agenti bilingui FR/EN, fuso WAT, CSAT 95%, da 3 $/h. 80% risparmio.',
      heroTitle: 'Call Center per il Camerun — Supporto Bilingue da Casablanca',
      heroSubtitle: 'Assistenza clienti bilingue FR/EN per il mercato camerunese. 80% in meno.',
    },
    pt: {
      title: 'Call Center Camarões | Atendimento Bilíngue FR/EN | Call IT Dev',
      description: 'Call center para Camarões: agentes bilíngues FR/EN, fuso WAT, CSAT 95%, a partir de 3 $/h. 80% economia.',
      heroTitle: 'Call Center para Camarões — Suporte Bilíngue de Casablanca',
      heroSubtitle: 'Atendimento bilíngue FR/EN para o mercado camaronês. 80% mais barato.',
    },
    nl: {
      title: 'Callcenter Kameroen | Tweetalige Klantenservice FR/EN | Call IT Dev',
      description: 'Callcenter voor Kameroen: tweetalige FR/EN-agenten, WAT-tijdzone, CSAT 95%, vanaf 3 $/u. 80% besparing.',
      heroTitle: 'Callcenter voor Kameroen — Tweetalige Support vanuit Casablanca',
      heroSubtitle: 'Premium tweetalige klantenservice voor de Kameroense markt. 80% goedkoper.',
    },
    pl: {
      title: 'Call Center Kamerun | Dwujęzyczna Obsługa FR/EN | Call IT Dev',
      description: 'Call center dla Kamerunu: dwujęzyczni agenci FR/EN, strefa WAT, CSAT 95%, od 3 $/h. 80% oszczędności.',
      heroTitle: 'Call Center dla Kamerunu — Dwujęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa dwujęzyczna obsługa dla rynku kameruńskiego. 80% taniej.',
    },
    tr: {
      title: 'Kamerun Çağrı Merkezi | İki Dilli Müşteri Hizmetleri FR/EN | Call IT Dev',
      description: 'Kamerun için çağrı merkezi: iki dilli FR/EN ajanlar, WAT saat dilimi, CSAT %95, 3 $/saatten başlayan.',
      heroTitle: 'Kamerun İçin Çağrı Merkezi — Kazablanka\'dan İki Dilli Destek',
      heroSubtitle: 'Kamerun pazarı için premium iki dilli müşteri deneyimi. %80 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Kamerun | Tvåspråkig Kundtjänst FR/EN | Call IT Dev',
      description: 'Callcenter för Kamerun: tvåspråkiga FR/EN-agenter, WAT-tidszon, CSAT 95%, från 3 $/h. 80% besparing.',
      heroTitle: 'Callcenter för Kamerun — Tvåspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium tvåspråkig kundtjänst för den kamerunska marknaden. 80% billigare.',
    },
    da: {
      title: 'Callcenter Cameroun | Tosproget Kundeservice FR/EN | Call IT Dev',
      description: 'Callcenter til Cameroun: tosprogede FR/EN-agenter, WAT-tidszone, CSAT 95%, fra 3 $/t. 80% besparelse.',
      heroTitle: 'Callcenter til Cameroun — Tosproget Support fra Casablanca',
      heroSubtitle: 'Premium tosproget kundeservice for det camerounske marked. 80% billigere.',
    },
    zh: {
      title: '喀麦隆呼叫中心 | 法英双语客服外包 | Call IT Dev',
      description: '喀麦隆呼叫中心外包：法英双语座席，WAT时区，CSAT 95%，3美元/小时起。节省80%。',
      heroTitle: '喀麦隆呼叫中心 — 卡萨布兰卡双语支持',
      heroSubtitle: '以超低价格提供喀麦隆市场优质双语客户服务。节省80%。',
    },
    ja: {
      title: 'カメルーンコールセンター | 仏英バイリンガルサポート | Call IT Dev',
      description: 'カメルーン向けコールセンター：仏英バイリンガル、WAT時間帯、CSAT 95%、3$/時間〜。80%コスト削減。',
      heroTitle: 'カメルーン向けコールセンター — カサブランカからのバイリンガルサポート',
      heroSubtitle: 'カメルーン市場向けプレミアムバイリンガル顧客サービス。80%低コスト。',
    },
    ko: {
      title: '카메룬 콜센터 | 불어/영어 이중 언어 고객 서비스 | Call IT Dev',
      description: '카메룬 콜센터 아웃소싱: 불어/영어 이중 언어, WAT 시간대, CSAT 95%, 시간당 3달러부터. 80% 절감.',
      heroTitle: '카메룬 콜센터 — 카사블랑카에서 이중 언어 지원',
      heroSubtitle: '카메룬 시장을 위한 프리미엄 이중 언어 고객 서비스. 80% 저렴.',
    },
    ru: {
      title: 'Колл-центр Камерун | Двуязычное обслуживание FR/EN | Call IT Dev',
      description: 'Колл-центр для Камеруна: двуязычные агенты FR/EN, часовой пояс WAT, CSAT 95%, от 3 $/ч. Экономия 80%.',
      heroTitle: 'Колл-центр для Камеруна — Двуязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для камерунского рынка. Часовой пояс WAT, на 80% дешевле.',
    },
  },

  senegal: {
    fr: {
      title: 'Centre d\'appel Sénégal | Service Client Francophone | Call IT Dev',
      description: 'Externalisez votre centre d\'appel au Sénégal : agents francophones natifs, fuseau GMT, CSAT 95%, dès 3 $/h. 80% d\'économies.',
      heroTitle: 'Centre d\'appel pour le Sénégal — Support francophone depuis Casablanca',
      heroSubtitle: 'Service client premium en français pour le marché sénégalais. Fuseau GMT, 80% moins cher.',
    },
    es: {
      title: 'Call Center Senegal | Atención al Cliente Francófona | Call IT Dev',
      description: 'Call center para Senegal: agentes francófonos nativos, zona GMT, CSAT 95%, desde 3 $/h. 80% ahorro.',
      heroTitle: 'Call Center para Senegal — Soporte Francófono desde Casablanca',
      heroSubtitle: 'Atención al cliente premium para el mercado senegalés. 80% más barato.',
    },
    de: {
      title: 'Call Center Senegal | Französischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Senegal: französischsprachige Agenten, GMT-Zeitzone, CSAT 95%, ab 3 $/h. 80% Ersparnis.',
      heroTitle: 'Call Center für Senegal — Französischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den senegalesischen Markt. 80% günstiger.',
    },
    ar: {
      title: 'مركز اتصال السنغال | خدمة عملاء بالفرنسية | Call IT Dev',
      description: 'مركز اتصال للسنغال: وكلاء فرنكوفونيون أصليون، منطقة GMT، CSAT 95%، من 3 $/ساعة. توفير 80%.',
      heroTitle: 'مركز اتصال للسنغال — دعم فرنكوفوني من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق السنغالي. منطقة GMT، أقل 80%.',
    },
    it: {
      title: 'Call Center Senegal | Assistenza Clienti Francofona | Call IT Dev',
      description: 'Call center per il Senegal: agenti francofoni, fuso GMT, CSAT 95%, da 3 $/h. 80% risparmio.',
      heroTitle: 'Call Center per il Senegal — Supporto Francofono da Casablanca',
      heroSubtitle: 'Assistenza clienti premium per il mercato senegalese. 80% in meno.',
    },
    pt: {
      title: 'Call Center Senegal | Atendimento Francófono | Call IT Dev',
      description: 'Call center para Senegal: agentes francófonos, fuso GMT, CSAT 95%, a partir de 3 $/h. 80% economia.',
      heroTitle: 'Call Center para Senegal — Suporte Francófono de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado senegalês. 80% mais barato.',
    },
    nl: {
      title: 'Callcenter Senegal | Franstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Senegal: Franstalige agenten, GMT-tijdzone, CSAT 95%, vanaf 3 $/u. 80% besparing.',
      heroTitle: 'Callcenter voor Senegal — Franstalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Senegalese markt. 80% goedkoper.',
    },
    pl: {
      title: 'Call Center Senegal | Frankofoniczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Senegalu: frankofonowie, strefa GMT, CSAT 95%, od 3 $/h. 80% oszczędności.',
      heroTitle: 'Call Center dla Senegalu — Frankofońskie Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku senegalskiego. 80% taniej.',
    },
    tr: {
      title: 'Senegal Çağrı Merkezi | Fransızca Müşteri Hizmetleri | Call IT Dev',
      description: 'Senegal için çağrı merkezi: Fransızca konuşanlar, GMT saat dilimi, CSAT %95, 3 $/saatten başlayan.',
      heroTitle: 'Senegal İçin Çağrı Merkezi — Kazablanka\'dan Fransızca Destek',
      heroSubtitle: 'Senegal pazarı için premium müşteri deneyimi. %80 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Senegal | Fransktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Senegal: fransktalande agenter, GMT-tidszon, CSAT 95%, från 3 $/h. 80% besparing.',
      heroTitle: 'Callcenter för Senegal — Fransktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den senegalesiska marknaden. 80% billigare.',
    },
    da: {
      title: 'Callcenter Senegal | Fransktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Senegal: fransktalende agenter, GMT-tidszone, CSAT 95%, fra 3 $/t. 80% besparelse.',
      heroTitle: 'Callcenter til Senegal — Fransktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det senegalesiske marked. 80% billigere.',
    },
    zh: {
      title: '塞内加尔呼叫中心 | 法语客服外包 | Call IT Dev',
      description: '塞内加尔呼叫中心外包：法语母语座席，GMT时区，CSAT 95%，3美元/小时起。节省80%。',
      heroTitle: '塞内加尔呼叫中心 — 卡萨布兰卡法语支持',
      heroSubtitle: '以超低价格提供塞内加尔市场优质法语客户服务。节省80%。',
    },
    ja: {
      title: 'セネガルコールセンター | フランス語カスタマーサポート | Call IT Dev',
      description: 'セネガル向けコールセンター：フランス語ネイティブ、GMT時間帯、CSAT 95%、3$/時間〜。80%コスト削減。',
      heroTitle: 'セネガル向けコールセンター — カサブランカからのフランス語サポート',
      heroSubtitle: 'セネガル市場向けプレミアムフランス語顧客サービス。80%低コスト。',
    },
    ko: {
      title: '세네갈 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '세네갈 콜센터 아웃소싱: 프랑스어 원어민, GMT 시간대, CSAT 95%, 시간당 3달러부터. 80% 절감.',
      heroTitle: '세네갈 콜센터 — 카사블랑카에서 프랑스어 지원',
      heroSubtitle: '세네갈 시장을 위한 프리미엄 프랑스어 고객 서비스. 80% 저렴.',
    },
    ru: {
      title: 'Колл-центр Сенегал | Франкоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Сенегала: франкоговорящие агенты, часовой пояс GMT, CSAT 95%, от 3 $/ч. Экономия 80%.',
      heroTitle: 'Колл-центр для Сенегала — Франкоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для сенегальского рынка. На 80% дешевле.',
    },
  },

  slovakia: {
    fr: {
      title: 'Centre d\'appel Slovaquie | Service Client Multilingue | Call IT Dev',
      description: 'Externalisez votre centre d\'appel en Slovaquie : agents multilingues, fuseau CET, CSAT 95%, dès 8 €/h. 50% d\'économies.',
      heroTitle: 'Centre d\'appel pour la Slovaquie — Support multilingue depuis Casablanca',
      heroSubtitle: 'Service client premium pour le marché slovaque. Fuseau CET, 50% moins cher.',
    },
    es: {
      title: 'Call Center Eslovaquia | Atención al Cliente Multilingüe | Call IT Dev',
      description: 'Call center para Eslovaquia: agentes multilingües, zona CET, CSAT 95%, desde 8 €/h. 50% ahorro.',
      heroTitle: 'Call Center para Eslovaquia — Soporte Multilingüe desde Casablanca',
      heroSubtitle: 'Atención premium para el mercado eslovaco. 50% más barato.',
    },
    de: {
      title: 'Call Center Slowakei | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für die Slowakei: mehrsprachige Agenten, CET-Zeitzone, CSAT 95%, ab 8 €/h. 50% Ersparnis.',
      heroTitle: 'Call Center für die Slowakei — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den slowakischen Markt. 50% günstiger.',
    },
    ar: {
      title: 'مركز اتصال سلوفاكيا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لسلوفاكيا: وكلاء متعددو اللغات، منطقة CET، CSAT 95%، من 8 €/ساعة. توفير 50%.',
      heroTitle: 'مركز اتصال لسلوفاكيا — دعم متعدد اللغات من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق السلوفاكي. توفير 50%.',
    },
    it: {
      title: 'Call Center Slovacchia | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per la Slovacchia: agenti multilingui, fuso CET, CSAT 95%, da 8 €/h. 50% risparmio.',
      heroTitle: 'Call Center per la Slovacchia — Supporto Multilingue da Casablanca',
      heroSubtitle: 'Assistenza premium per il mercato slovacco. 50% in meno.',
    },
    pt: {
      title: 'Call Center Eslováquia | Atendimento Multilíngue | Call IT Dev',
      description: 'Call center para Eslováquia: agentes multilíngues, fuso CET, CSAT 95%, a partir de 8 €/h. 50% economia.',
      heroTitle: 'Call Center para Eslováquia — Suporte Multilíngue de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado eslovaco. 50% mais barato.',
    },
    nl: {
      title: 'Callcenter Slowakije | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Slowakije: meertalige agenten, CET-tijdzone, CSAT 95%, vanaf 8 €/u. 50% besparing.',
      heroTitle: 'Callcenter voor Slowakije — Meertalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Slowaakse markt. 50% goedkoper.',
    },
    pl: {
      title: 'Call Center Słowacja | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Słowacji: wielojęzyczni agenci, strefa CET, CSAT 95%, od 8 €/h. 50% oszczędności.',
      heroTitle: 'Call Center dla Słowacji — Wielojęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku słowackiego. 50% taniej.',
    },
    tr: {
      title: 'Slovakya Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Slovakya için çağrı merkezi: çok dilli ajanlar, CET saat dilimi, CSAT %95, 8 €/saatten başlayan.',
      heroTitle: 'Slovakya İçin Çağrı Merkezi — Kazablanka\'dan Çok Dilli Destek',
      heroSubtitle: 'Slovakya pazarı için premium müşteri deneyimi. %50 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Slovakien | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Slovakien: flerspråkiga agenter, CET-tidszon, CSAT 95%, från 8 €/h. 50% besparing.',
      heroTitle: 'Callcenter för Slovakien — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den slovakiska marknaden. 50% billigare.',
    },
    da: {
      title: 'Callcenter Slovakiet | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Slovakiet: flersprogede agenter, CET-tidszone, CSAT 95%, fra 3 €/t. 50% besparelse.',
      heroTitle: 'Callcenter til Slovakiet — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det slovakiske marked. 50% billigere.',
    },
    zh: {
      title: '斯洛伐克呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '斯洛伐克呼叫中心外包：多语言座席，CET时区，CSAT 95%，3€/小时起。节省50%。',
      heroTitle: '斯洛伐克呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以nearshore价格提供斯洛伐克市场优质客户服务。节省50%。',
    },
    ja: {
      title: 'スロバキアコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'スロバキア向けコールセンター：多言語対応、CET時間帯、CSAT 95%、3€/時間〜。50%コスト削減。',
      heroTitle: 'スロバキア向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'スロバキア市場向けプレミアム顧客サービス。50%低コスト。',
    },
    ko: {
      title: '슬로바키아 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '슬로바키아 콜센터: 다국어 상담원, CET 시간대, CSAT 95%, 3€/시간부터. 50% 절감.',
      heroTitle: '슬로바키아 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '슬로바키아 시장을 위한 프리미엄 고객 서비스. 50% 저렴.',
    },
    ru: {
      title: 'Колл-центр Словакия | Многоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Словакии: многоязычные агенты, часовой пояс CET, CSAT 95%, от 3 €/ч. Экономия 50%.',
      heroTitle: 'Колл-центр для Словакии — Многоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для словацкого рынка. На 50% дешевле.',
    },
  },

  // Gap-fill: Lithuania missing languages
  lithuania: {
    zh: {
      title: '立陶宛呼叫中心 | 客服外包 | Call IT Dev',
      description: '立陶宛呼叫中心外包：多语言座席，EET时区，CSAT 95%，10€/小时起。金融科技专长。',
      heroTitle: '立陶宛呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以nearshore价格提供立陶宛市场优质客户服务。EET时区。',
    },
    ja: {
      title: 'リトアニアコールセンター | カスタマーサポート外注 | Call IT Dev',
      description: 'リトアニア向けコールセンター：多言語対応、EET時間帯、CSAT 95%、10€/時間〜。フィンテック専門。',
      heroTitle: 'リトアニア向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'リトアニア市場向けプレミアム顧客サービス。EET時間帯。',
    },
    ko: {
      title: '리투아니아 콜센터 | 고객 서비스 아웃소싱 | Call IT Dev',
      description: '리투아니아 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 10€/시간부터. 핀테크 전문.',
      heroTitle: '리투아니아 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '리투아니아 시장을 위한 프리미엄 고객 서비스. EET 시간대.',
    },
    sv: {
      title: 'Callcenter Litauen | Kundtjänst Outsourcing | Call IT Dev',
      description: 'Callcenter för Litauen: flerspråkiga agenter, EET-tidszon, CSAT 95%, från 10 €/h. Fintech-expertis.',
      heroTitle: 'Callcenter för Litauen — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den litauiska marknaden. EET-tidszon.',
    },
    da: {
      title: 'Callcenter Litauen | Kundeservice Outsourcing | Call IT Dev',
      description: 'Callcenter til Litauen: flersprogede agenter, EET-tidszone, CSAT 95%, fra 10 €/t. Fintech-ekspertise.',
      heroTitle: 'Callcenter til Litauen — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det litauiske marked. EET-tidszone.',
    },
  },

  // Gap-fill: Rwanda missing languages  
  rwanda: {
    zh: {
      title: '卢旺达呼叫中心 | 客服外包 | Call IT Dev',
      description: '卢旺达呼叫中心外包：多语言座席，CAT时区，CSAT 95%，3美元/小时起。非洲科技中心。',
      heroTitle: '卢旺达呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以超低价格提供卢旺达市场优质客户服务。节省80%。',
    },
    ja: {
      title: 'ルワンダコールセンター | カスタマーサポート外注 | Call IT Dev',
      description: 'ルワンダ向けコールセンター：多言語対応、CAT時間帯、CSAT 95%、3$/時間〜。アフリカテックハブ。',
      heroTitle: 'ルワンダ向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'ルワンダ市場向けプレミアム顧客サービス。80%低コスト。',
    },
    ko: {
      title: '르완다 콜센터 | 고객 서비스 아웃소싱 | Call IT Dev',
      description: '르완다 콜센터: 다국어 상담원, CAT 시간대, CSAT 95%, 시간당 3달러부터. 아프리카 테크 허브.',
      heroTitle: '르완다 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '르완다 시장을 위한 프리미엄 고객 서비스. 80% 저렴.',
    },
    sv: {
      title: 'Callcenter Rwanda | Kundtjänst Outsourcing | Call IT Dev',
      description: 'Callcenter för Rwanda: flerspråkiga agenter, CAT-tidszon, CSAT 95%, från 3 $/h. Afrikas tech-hub.',
      heroTitle: 'Callcenter för Rwanda — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den rwandiska marknaden. 80% billigare.',
    },
    da: {
      title: 'Callcenter Rwanda | Kundeservice Outsourcing | Call IT Dev',
      description: 'Callcenter til Rwanda: flersprogede agenter, CAT-tidszone, CSAT 95%, fra 3 $/t. Afrikas tech-hub.',
      heroTitle: 'Callcenter til Rwanda — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det rwandiske marked. 80% billigere.',
    },
  },

  // Gap-fill: Kuwait missing languages
  kuwait: {
    zh: {
      title: '科威特呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '科威特呼叫中心外包：阿拉伯语母语座席，AST时区，CSAT 95%，5美元/小时起。节省70%。',
      heroTitle: '科威特呼叫中心 — 卡萨布兰卡阿拉伯语支持',
      heroSubtitle: '以超低价格提供科威特市场优质阿拉伯语客户服务。节省70%。',
    },
    ja: {
      title: 'クウェートコールセンター | アラビア語カスタマーサポート | Call IT Dev',
      description: 'クウェート向けコールセンター：アラビア語ネイティブ、AST時間帯、CSAT 95%、5$/時間〜。70%コスト削減。',
      heroTitle: 'クウェート向けコールセンター — カサブランカからのアラビア語サポート',
      heroSubtitle: 'クウェート市場向けプレミアムアラビア語顧客サービス。70%低コスト。',
    },
    ko: {
      title: '쿠웨이트 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '쿠웨이트 콜센터: 아랍어 원어민, AST 시간대, CSAT 95%, 시간당 5달러부터. 70% 절감.',
      heroTitle: '쿠웨이트 콜센터 — 카사블랑카에서 아랍어 지원',
      heroSubtitle: '쿠웨이트 시장을 위한 프리미엄 아랍어 고객 서비스. 70% 저렴.',
    },
    sv: {
      title: 'Callcenter Kuwait | Arabisktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Kuwait: arabisktalande agenter, AST-tidszon, CSAT 95%, från 5 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Kuwait — Arabisktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den kuwaitiska marknaden. 70% billigare.',
    },
    da: {
      title: 'Callcenter Kuwait | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Kuwait: arabisktalende agenter, AST-tidszone, CSAT 95%, fra 5 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Kuwait — Arabisktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det kuwaitiske marked. 70% billigere.',
    },
  },

};
